export class PasswordData {
  public userId: string;
  public password: string;
}